module.exports = __webpack_public_path__ + "static/media/barack_obama.b0986235.jpg";